/**
 * 奖惩规则创建与编辑
 */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './RewardModal.module.scss';
import http from '@/assets/api/http';
import model from '@/reducers/system/operatingrule/model';
import { regYuanToFen, } from '@/util/money';

import Punishment from '../components/Punishment';
import Reward from '../components/Reward';
import moment from 'moment';
import { FloatConversion } from '@/util/conversion';

import {
    Modal,
    message,
    Form,
    Radio,
    Row,
    Col,
    Space,
} from 'antd';

const formItemLayout = {
    labelCol: {
        sm: { span: 4 },
    },
    wrapperCol: {
        sm: { span: 20 },
    },
};


const FormItem = Form.Item;
const RadioGroup = Radio.Group;



class RewardModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            titleTag: this.props.title,
            visible: this.props.visible,
            confirmLoading: false,
        };
        this.floatConversion = new FloatConversion();
    }

    componentDidMount() {
        const { data, getRewardType } = this.props;
        getRewardType();//类型(奖励/惩罚)
        if (data) {
            this.props.getRewardRuleDetail({ id: data });//详情
        }
    }

    componentWillUnmount() {
        const { data } = this.props;
        if (data) {
            this.props.getCleanDetail();
        }
    }

    _handleOk = () => {
        // this.handleSubmit();

        this.formRef.validateFields().then((values) => {
            console.log(values, '提交');
        }).catch((info) => {
            console.log('Validate Failed:', info);
        });
    }

    _handleCancel = () => {
        this.setState({
            visible: false,
        });
        this.props.closeMode();
    }


    handleSubmit = e => {//表单校验
        if (e) e.preventDefault();
        this.props.form.validateFields((err, fieldsValue) => {
            if (!err) {
                // console.log('提交', fieldsValue);
                const { ruleType } = fieldsValue;
                const { data } = this.props;
                let submitData = {};
                let submitUrl = data ? 'edit' : 'save';

                if (ruleType == 'REWARD') {
                    const { rewardReasons, rewardDate, rewardFine, rewardServiceScore, rewardLevelScore, rewardComprehensive,
                        rewardRealVoice, rewardMerchantsVoice, rewardAmount, rewardAmountEvery, } = fieldsValue;
                    let startTime = null, endTime = null;
                    if (Array.isArray(rewardDate) && rewardDate.length === 2) {
                        //判断起始和当前时间关系
                        if (moment(rewardDate[0]).valueOf() < moment().valueOf()) {
                            return message.warning('起始时间不小于当前时间');
                        }
                        startTime = rewardDate[0].format('YYYY-MM-DD HH:mm:ss');
                        endTime = rewardDate[1].format('YYYY-MM-DD HH:mm:ss');
                    }

                    submitData = {
                        id: data ? data : undefined,
                        name: rewardReasons,
                        gmtStart: startTime,
                        gmtEnd: endTime,
                        rewardValue: regYuanToFen(rewardFine),
                        serviceNum: rewardServiceScore,
                        lvNum: rewardLevelScore,
                        triggerType: rewardComprehensive,
                        type: ruleType,
                        triggerConditionReq: {
                            userPraiseNum: rewardRealVoice,
                            merchantPraiseNum: rewardMerchantsVoice,
                            deliveryAmount: rewardAmount ? regYuanToFen(rewardAmount) : undefined,
                            freeOrderNum: rewardAmountEvery,
                        }
                    };
                } else {

                    const { punishReasons, punishDate, punishFine, punishServiceScore, punishLevelScore, punishComprehensive,
                        punishDistribution, punishDistributionQ, punishNoReason, punishShielding, } = fieldsValue;
                    let startTime = null, endTime = null;
                    if (Array.isArray(punishDate) && punishDate.length === 2) {
                        //判断起始和当前时间关系
                        if (moment(punishDate[0]).valueOf() < moment().valueOf()) {
                            return message.warning('起始时间不小于当前时间');
                        }
                        startTime = punishDate[0].format('YYYY-MM-DD HH:mm:ss');
                        endTime = punishDate[1].format('YYYY-MM-DD HH:mm:ss');
                    }

                    submitData = {
                        id: data ? data : undefined,
                        name: punishReasons,
                        gmtStart: startTime,
                        gmtEnd: endTime,
                        rewardValue: regYuanToFen(punishFine),
                        serviceNum: punishServiceScore,
                        lvNum: punishLevelScore,
                        triggerType: punishComprehensive,
                        type: ruleType,
                        pullBlack: this.floatConversion.multiply(punishShielding, 1440),
                        triggerConditionReq: {
                            deliveryTimeout: punishDistribution,
                            deliveryTimeoutNum: punishDistributionQ,
                            cancelNum: punishNoReason,
                        }
                    };

                }

                this.setState({ confirmLoading: true }, () => {
                    http(`/reward/rule/${submitUrl}`, submitData, 'POST').then(() => {
                        data ? message.success('更新成功') : message.success('新建成功');
                        this.setState({
                            confirmLoading: false,
                            visible: false,
                        });
                        this.props.closeMode(true);
                    }).catch((e = {}) => {
                        message.error(e.message);
                        this.setState({
                            confirmLoading: false,
                        });
                    });
                });
            }
        });
    };


    render() {
        const { visible, confirmLoading, titleTag } = this.state;
        const { data, details, form, rewardType } = this.props;
        const { type = {} } = details;
        return (
            <Modal
                width={600}
                centered
                title={titleTag}
                visible={visible}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'

            >

                <Form
                    {...formItemLayout}
                    className={styles.container}
                    autoComplete='off'
                    name="create"
                    scrollToFirstError
                    ref={(formRef) => this.formRef = formRef}
                >
                    <Row>
                        <Col offset={6} span={18}>
                            <FormItem
                                name="ruleType"
                                colon={false}
                                initialValue={'1'}
                                rules={[
                                    { required: true, message: '请选择规则类型' },
                                ]}
                            >
                                <RadioGroup onChange={this.cardTypeHandle}>
                                    <Space size={130}>
                                        <Radio value="0">奖励</Radio>
                                        <Radio value="1">惩罚</Radio>
                                    </Space>
                                </RadioGroup>
                            </FormItem>
                        </Col>
                    </Row>
                    <FormItem
                        noStyle
                        shouldUpdate={(prevValues, currentValues) => prevValues.ruleType !== currentValues.ruleType}
                    >
                        {({ getFieldValue }) => {
                            const Inputh = getFieldValue('ruleType') === '0' ? (
                                <Reward data={data} details={details} form={this.formRef} />
                            ) : <Punishment data={data} details={details} form={this.formRef} />
                            return Inputh;
                        }}
                    </FormItem>
                </Form>
            </Modal>
        );

    }
}

RewardModal.propTypes = {
    data: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // 弹框入参
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string,// 弹框标题


    details: PropTypes.object,
    getRewardRuleDetail: PropTypes.func,//详情数据(action)
    getCleanDetail: PropTypes.func,//清除详情数据(action)

    rewardType: PropTypes.array,
    getRewardType: PropTypes.func,//类型(奖励/惩罚)(action)

};

const mapStateToProps = (state) => {
    return {
        details: state.operatingrule.details,
        rewardType: state.operatingrule.rewardType,
    };
};

export default connect(mapStateToProps, model.actions)(RewardModal);